import { FilePreview } from '~shared/ui/file-preview';

import { Button } from '@breezeventures/ui-kit/button';
import { Loader } from '@breezeventures/ui-kit/loader';
import { Icon } from '@breezeventures/ui-kit/next/icon';
import { Typography } from '@breezeventures/ui-kit/typography';

export type FileRowProps = {
  name: string;
  isImage: boolean;
  previewUrl?: string;
  uploadingState?: { progress: number } | { indeterminate: true };
  error?: string;
  onRemove: () => void;
};

export const FileRow = ({
  name,
  isImage,
  previewUrl,
  uploadingState,
  error,
  onRemove,
}: FileRowProps) => {
  const showProgressBar = uploadingState && 'progress' in uploadingState;
  const showSpinnerOverPreview =
    uploadingState &&
    'indeterminate' in uploadingState &&
    uploadingState.indeterminate;

  return (
    <div className="flex items-center gap-4">
      <div className="relative shrink-0">
        <FilePreview isImage={isImage} previewUrl={previewUrl} />
        {showSpinnerOverPreview && (
          <div
            className={`
              absolute inset-0 flex items-center justify-center rounded-lg
              bg-black/40
            `}
          >
            <Loader className="size-6 text-white" />
          </div>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <Typography.Text
          size="xs"
          color="secondary"
          className="wrap-break-word"
        >
          {name}
        </Typography.Text>

        {error && (
          <Typography.Text size="2xs" color="negative">
            {error}
          </Typography.Text>
        )}

        {showProgressBar && (
          <div
            className={`relative my-2 h-0.5 w-full rounded-full bg-neutral-100`}
          >
            <div
              className={`
                h-full rounded-full bg-primitive-accent-brand transition-all
              `}
              style={{ width: `${uploadingState.progress}%` }}
            />
          </div>
        )}
      </div>

      <Button
        size="s"
        variant="secondary"
        className="size-10!"
        onClick={onRemove}
      >
        <Icon
          name="trash"
          size={24}
          version="v1"
          color="var(--color-primitive-secondary)"
        />
      </Button>
    </div>
  );
};
